import { Component, HostListener, Inject, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { OfertasSolicitudComponent } from '../ofertas-solicitud/ofertas-solicitud.component';
import { Solicitud } from '../../../../../interfaces/interface-bakend/ofertas-laborales/solicitudes.interface';
import {
    APP_CONFIG_OFERTAS,
    IAppOfertas,
} from '../../../../../app.config/app.config-ofertas';
import { SolicitudesService } from '../../../../../services/ofertas-laborales/solicitudes.service';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SignoSede } from 'src/app/interfaces/interface-bakend/entidades/signo-sede.interface';
import { SignoSedeService } from 'src/app/services/entidades/signo-sedes.service';
import { SignoPlan } from 'src/app/interfaces/interface-bakend/entidades/signo-plan.interface';
import { SignoPlanService } from '@services/entidades/signo-planes.service';
import { Actividad } from '@interfaces/interface-bakend/ofertas-laborales/actividad.interface';
import { ActividadesService } from '@services/ofertas-laborales/actividades.service';
import { ModalDetalleGecrosComponent } from '@components/usuarios/pages/modal-detalle-gecros/modal-detalle-gecros.component';
import { ModalDetalleComponent } from '@components/usuarios/pages/modal-detalle/modal-detalle.component';
import * as XLSX from 'xlsx';
import { RECUPERO_PERFIL_KEY } from '../../../common/helpers/recupero.helper';
import { PasoStepper } from '../stepper/stepper.component';
import { PopUpModalCustomService } from '@services/shared/popup-modal-custom.service';
import { SolicitudesSocketService } from '@services/solicitudes/solicitudes-socket.service';

@Component({
    selector: 'app-ofertas-listado',
    templateUrl: './ofertas-listado.component.html',
    styleUrls: ['./ofertas-listado.component.scss'],
})
export class OfertasListadoComponent implements OnInit, OnDestroy {
    flagLoaded = true;
    flagCargandoTramites = true;
    private readyPromise: Promise<void> = Promise.resolve();
    private textoTimer: any;
    private refreshTimer: any;
    private refrescando = false;
    private socketSub: Subscription;
    private eventoTimer: any;

    /** Numero de la ultima consulta disparada: las respuestas viejas se descartan. */
    private consultaId = 0;

    /**
     * De donde sale el filtro de la bandeja. Con 'rango' manda las fechas del
     * datepicker y no manda q; con 'texto' manda q sobre todo el historial.
     */
    modoBusqueda: 'rango' | 'texto' = 'rango';

    /** Rango abierto para "Buscar todo": el back siempre exige fechas. */
    private readonly FECHA_TODO_DESDE = '2000-01-01';
    private readonly FECHA_TODO_HASTA = '2099-12-31';

    @ViewChild('infoEstadosTpl') infoEstadosTpl: TemplateRef<any>;

    /**
     * Pasos del recap "Información sobre Estados". Pisan los pasos por
     * defecto del stepper, que están redactados para el afiliado.
     */
    readonly pasosInfoEstados: PasoStepper[] = [
        {
            estado: 0,
            label: 'Presentado',
            descripcion: 'El afiliado inicia el trámite.',
        },
        {
            estado: 1,
            label: 'Documentación',
            descripcion: 'Se carga la documentación requerida.',
        },
        {
            estado: 2,
            label: 'En Revisión',
            descripcion:
                'Los perfiles <strong class="perfil">SEDE</strong> y ' +
                '<strong class="perfil">RECUPEROSUR</strong> revisan el ' +
                'trámite y pueden derivarlo a Recupero.',
        },
        {
            estado: 7,
            label: 'Recupero',
            icon: 'autorenew',
            descripcion:
                'El perfil <strong class="perfil">RECUPEROSUR</strong> ' +
                'gestiona el trámite y lo deriva a Auditoría Médica.',
        },
        {
            estado: 3,
            label: 'En Auditoría Médica',
            descripcion:
                'Solo el perfil <strong class="perfil">AUDITORIA</strong> ' +
                'puede aprobar este tipo de trámite.',
        },
        {
            estado: 4,
            label: 'Aprobado',
            descripcion:
                'El trámite queda resuelto y se notifica la autorización al afiliado.',
        },
    ];
    selectSede: string[] = [];
    solicitudesPaginadas: any[] = [];
    totalPaginas: number = 1;
    totalResultados: number = 0;
    textoFiltro: string = '';
    paginaActual: number = 1;
    pageSize: number = 10;
    pageSizeOptions: number[] = [5, 10, 25, 100];
    skeletonRows: number[] = [1, 2, 3, 4, 5, 6];

    // Menú kebab de acciones
    menuSolicitud: any = null;
    menuPos = { top: 0, right: 0 };

    // Dropdowns de filtros (Sede / Estado / Plan)
    dropdownAbierto: 'sede' | 'estado' | 'plan' | null = null;
    dropdownPos = { top: 0, left: 0 };

    // Tooltip custom
    tooltipVisible: boolean = false;
    tooltipTexto: string = '';
    tooltipPos = { top: 0, left: 0 };
    tooltipTimeout: any = null;

    private newStateSubscription: Subscription;
    sedes: SignoSede[] = [];
    sedesByUsuario: SignoSede[] = [];
    selectedEstados: number[] = [];
    actividades: Actividad[] = [];
    idActividadSeleccionada: string;
    /** Id centinela del trámite sintético "Todos" (no es una actividad real). */
    readonly TODOS_ID = '__TODOS__';
    /** Orden por fecha de la tabla (click en el header Fecha). */
    ordenFecha: 'asc' | 'desc' = 'desc';
    /**
     * Planes del catálogo signo_planes (los mismos que administra
     * /planes-listado) y los seleccionados en el filtro.
     */
    planes: SignoPlan[] = [];
    selectedPlanes: string[] = [];
    /** Columna por la que ordena la tabla. */
    sortBy: 'fecha' | 'plan' | 'dif' = 'fecha';
    /** Dirección del orden cuando la tabla ordena por plan. */
    ordenPlan: 'asc' | 'desc' = 'asc';
    /**
     * Dirección del orden cuando la tabla ordena por Dif. Arranca en asc: los
     * netos mas bajos (mas anuladas que aprobadas) primero.
     */
    ordenDif: 'asc' | 'desc' = 'asc';
    flagSolicitudesCargadas = false;
    userPerfilKey: string;

    get esPerfilRecupero(): boolean {
        return this.userPerfilKey === RECUPERO_PERFIL_KEY;
    }
    solicitudCounts: {
        pendientes: { [key: string]: number };
        leidas: { [key: string]: number };
    } = {
        pendientes: {},
        leidas: {},
    };

    fechaDesde: Date;
    fechaHasta: Date;
    fechaDesdeStr: string = '';
    fechaHastaStr: string = '';

    cantidadSolicitudesPendientes = 0;
    cantidadSolicitudesLeidas = 0;
    cantidadSolicitudesTotal = 0;

    loading: boolean = false;

    // IDs de actividades de inscripción (ahora excluidas de este listado)
    private readonly idsInscripciones: string[] = [
        '68c9c64799bb6b0adb6715c8',
        '68c9c61e99bb6b0adb671593',
        '68c86b61e6c4fc16024be451',
    ];

    private readonly FECHA_CORTE_FILTRO = new Date('2026-08-04T00:00:00.000Z');

    constructor(
        @Inject(APP_CONFIG_OFERTAS) public iAppOfertas: IAppOfertas,
        private solicitudesService: SolicitudesService,
        public dialog: MatDialog,
        private authService: AuthService,
        private signoSedeService: SignoSedeService,
        private signoPlanService: SignoPlanService,
        private actividadesService: ActividadesService,
        private snackBar: MatSnackBar,
        private modalCustom: PopUpModalCustomService,
        private solicitudesSocket: SolicitudesSocketService
    ) {
        this.newStateSubscription = this.solicitudesService
            .getsetNewStater()
            .subscribe((resp) => {
                const solicitudIndex = this.solicitudesPaginadas.findIndex(
                    (solicitud) => solicitud._id === resp?.state?._id
                );

                if (solicitudIndex !== -1) {
                    this.solicitudesPaginadas[
                        solicitudIndex
                    ].lastState_numberState =
                        resp.state?.lastState?.numberState;
                }
            });
    }

    establecerFechadeBusqueda(): void {
        const ahora = new Date();
        this.fechaDesde = new Date(ahora.getFullYear(), ahora.getMonth(), 1);
        this.fechaHasta = new Date(
            ahora.getFullYear(),
            ahora.getMonth() + 1,
            0
        );
        this.fechaDesdeStr = this.formatDate(this.fechaDesde);
        this.fechaHastaStr = this.formatDate(this.fechaHasta);
    }

    async ngOnInit(): Promise<void> {
        this.estadosChips = this.iAppOfertas.selectEstados.filter(
            (e) => e.number <= 7
        );
        // Estado inicial: todos los estados visibles (0-7) seleccionados
        this.selectedEstados = this.estadosChips.map((e) => e.number);
        this.establecerFechadeBusqueda();
        this.readyPromise = this.inicializar();
        // Desactivado: evita peticiones periodicas automaticas y saturacion de red
        // this.iniciarAutoRefresh();
        // this.conectarSocket();
    }

    /**
     * Arranque de la bandeja: sedes del usuario + trámites. Nunca rechaza,
     * así un error de sedes no impide cargar los trámites ni deja colgado
     * el primer "Buscar".
     */
    private async inicializar(): Promise<void> {
        try {
            await this.getSedesPorUsuario();
        } catch (error) {
            console.warn('No se pudieron cargar las sedes del usuario:', error);
        }
        try {
            await this.getPlanes();
        } catch (error) {
            console.warn('No se pudieron cargar los planes:', error);
        }
        await this.getActividades();
    }

    ngOnDestroy(): void {
        if (this.newStateSubscription) {
            this.newStateSubscription.unsubscribe();
        }
        if (this.textoTimer) {
            clearTimeout(this.textoTimer);
        }
        if (this.refreshTimer) {
            clearInterval(this.refreshTimer);
        }
        if (this.eventoTimer) {
            clearTimeout(this.eventoTimer);
        }
        if (this.socketSub) {
            this.socketSub.unsubscribe();
        }
        this.solicitudesSocket.desconectar();
    }

    formatDate(date: Date): string {
        return date.toISOString().split('T')[0];
    }

    async buscarPorFechas() {
        // El boton de rango busca solo por fechas: sin q.
        this.modoBusqueda = 'rango';
        // Garantiza que los trámites ya estén cargados aunque el usuario
        // clickee antes de que termine la carga inicial (red lenta).
        await this.readyPromise;
        if (!this.actividades?.length) {
            await this.getActividades();
        }
        if (!this.fechaDesdeStr || !this.fechaHastaStr) {
            this.snackBar.open('Por favor, seleccione ambas fechas', 'Cerrar', {
                duration: 3000,
            });
            return;
        }
        await this.fetchPage(1);
    }

    /**
     * Carga UNA página de la bandeja desde el backend (server-side). Los
     * filtros (sedes, estados, trámite, texto) se resuelven en el servidor y
     * solo se transfiere la página + totales + contadores por trámite.
     */
    async fetchPage(page: number = 1, silencioso: boolean = false): Promise<void> {
        // En modo silencioso (auto-refresh) no se muestra skeleton ni se vacía
        // la lista ante un error transitorio, y no se solapan refrescos.
        if (silencioso && this.refrescando) {
            return;
        }
        this.refrescando = true;
        try {
            await this.readyPromise;
        } catch (error) {
            // Si la inicializacion fallo no dejamos el flag trabado: eso
            // cortaria todos los refrescos automaticos para siempre.
            console.error('No se pudo inicializar la bandeja:', error);
            this.refrescando = false;
            return;
        }
        const miConsulta = ++this.consultaId;
        this.paginaActual = Math.max(1, page);
        if (!silencioso) {
            this.flagLoaded = false;
        }
        this.flagSolicitudesCargadas = true;

        // Sin sedes o sin estados seleccionados => 0 resultados (filtro real)
        if (this.selectSede.length === 0 || this.selectedEstados.length === 0) {
            if (miConsulta === this.consultaId) {
                this.solicitudesPaginadas = [];
                this.totalResultados = 0;
                this.totalPaginas = 1;
                this.solicitudCounts = { pendientes: {}, leidas: {} };
                this.recalcularTotales();
                this.refrescando = false;
                if (!silencioso) {
                    this.flagLoaded = true;
                }
            }
            return;
        }

        const params = {
            signoSedes: this.selectSede,
            fechaDesde: this.fechaDesdeStr,
            fechaHasta: this.fechaHastaStr,
            states: this.selectedEstados,
            actividad:
                this.idActividadSeleccionada === this.TODOS_ID
                    ? undefined
                    : this.idActividadSeleccionada,
            q:
                this.modoBusqueda === 'texto' && this.textoFiltro
                    ? this.textoFiltro.trim()
                    : undefined,
            page: this.paginaActual,
            limit: this.pageSize,
            planes: this.planesFiltro(),
            sortBy: this.sortBy,
            orden:
                this.sortBy === 'plan'
                    ? this.ordenPlan
                    : this.sortBy === 'dif'
                    ? this.ordenDif
                    : this.ordenFecha,
        };

        try {
            const resp = this.esPerfilRecupero
                ? await this.solicitudesService.getSolicitudesRecuperoPaged(
                      params
                  )
                : await this.solicitudesService.getSolicitudesBySedePaged(
                      params
                  );

            if (miConsulta !== this.consultaId) {
                // Llego una respuesta vieja: la consulta vigente es otra.
                return;
            }

            this.solicitudesPaginadas = resp.data || [];
            this.totalResultados = resp.total || 0;
            this.totalPaginas = Math.max(
                1,
                Math.ceil(this.totalResultados / this.pageSize)
            );
            this.solicitudCounts = resp.counts || {
                pendientes: {},
                leidas: {},
            };
            this.recalcularTotales();
        } catch (error) {
            console.error('Error al cargar la bandeja:', error);
            if (!silencioso) {
                this.solicitudesPaginadas = [];
                this.totalResultados = 0;
                this.totalPaginas = 1;
                this.solicitudCounts = { pendientes: {}, leidas: {} };
                this.recalcularTotales();
                this.snackBar.open('Error al cargar las solicitudes', 'Cerrar', {
                    duration: 3000,
                });
            }
        } finally {
            if (miConsulta === this.consultaId) {
                this.refrescando = false;
                if (!silencioso) {
                    this.flagLoaded = true;
                }
            }
        }
    }

    /**
     * Refresco automático de la bandeja (Fase 3). Con la paginación el payload
     * de una página es chico, así que re-consultar la página actual cada 30 s
     * la mantiene fresca sin infra extra. Se pausa si la pestaña no está
     * visible y se refresca al recuperar el foco.
     */
    private iniciarAutoRefresh(): void {
        if (this.refreshTimer) {
            return;
        }
        this.refreshTimer = setInterval(() => {
            if (
                document.visibilityState === 'visible' &&
                this.flagSolicitudesCargadas &&
                !this.loading &&
                !this.refrescando
            ) {
                this.fetchPage(this.paginaActual, true);
            }
        }, 30000);
    }

    /**
     * Se conecta al socket de la bandeja (Fase 3). El backend emite un "poke"
     * cuando cambia una solicitud; acá se refresca la página actual en silencio
     * (debounced) para no re-consultar por cada evento.
     */
    private async conectarSocket(): Promise<void> {
        try {
            const token = await this.authService.loadJwToken();
            if (!token) {
                return;
            }
            this.solicitudesSocket.conectar(token);
            this.socketSub = this.solicitudesSocket.cambio$.subscribe(() => {
                if (this.eventoTimer) {
                    clearTimeout(this.eventoTimer);
                }
                this.eventoTimer = setTimeout(() => {
                    if (this.flagSolicitudesCargadas && !this.loading) {
                        this.fetchPage(this.paginaActual, true);
                    }
                }, 400);
            });
        } catch (error) {
            console.warn('No se pudo conectar el socket de la bandeja:', error);
        }
    }

    // Listeners desactivados para evitar re-consultas automaticas al cambiar de ventana o foco
    /*
    @HostListener('window:focus')
    onWindowFocus(): void {
        if (this.flagSolicitudesCargadas && !this.loading && !this.refrescando) {
            this.fetchPage(this.paginaActual, true);
        }
    }

    @HostListener('document:visibilitychange')
    onVisibilityChange(): void {
        if (
            document.visibilityState === 'visible' &&
            this.flagSolicitudesCargadas &&
            !this.loading &&
            !this.refrescando
        ) {
            this.fetchPage(this.paginaActual, true);
        }
    }
    */

    /** Total de pendientes/leídas/total a partir de los contadores del back. */
    private recalcularTotales(): void {
        this.cantidadSolicitudesPendientes = this.getTotalPendientes();
        this.cantidadSolicitudesLeidas = this.getTotalLeidas();
        this.cantidadSolicitudesTotal =
            this.cantidadSolicitudesPendientes + this.cantidadSolicitudesLeidas;
    }

    // Obtiene todas las actividades EXCEPTO las de inscripción
    async getActividades() {
        this.flagCargandoTramites = true;
        try {
            const todas = await this.actividadesService.getActividades();
            this.actividades = todas.filter(
                (a) => !this.idsInscripciones.includes(a._id)
            );

            // Por defecto arranca en "Todos".
            this.idActividadSeleccionada = this.TODOS_ID;
        } finally {
            this.flagCargandoTramites = false;
        }
    }

    async getSedesPorUsuario(): Promise<string[]> {
        this.sedes = await this.signoSedeService.getSedes();
        const usuario = await this.authService.getUserLogon();
        this.userPerfilKey = usuario?.perfil?.key;
        if (this.sedes !== undefined) {
            const sedesUsuario = usuario?.signoSedes ?? [];
            this.sedesByUsuario = this.sedes.filter((sede: any) =>
                sedesUsuario.includes(sede?._id)
            );
            this.checkSedes();
        }
        return this.selectSede;
    }

    /**
     * Planes del catálogo signo_planes — los mismos que administra
     * /planes-listado. Nunca rompe la carga inicial.
     */
    async getPlanes(): Promise<void> {
        const planes = await this.signoPlanService.getPlanes();
        this.planes = (planes || [])
            .filter((plan) => !!plan && !!plan._id)
            .sort((a, b) => (a.idRef || 0) - (b.idRef || 0));
    }

    /** Id del plan como string, para el template. */
    idPlan(plan: SignoPlan): string {
        return plan._id as string;
    }

    /** Opciones del filtro: los planes del catálogo. */
    private opcionesPlan(): string[] {
        return this.planes.map((plan) => this.idPlan(plan));
    }

    /**
     * Opciones que viajan al back: sin selección no se filtra, y con todas
     * seleccionadas tampoco (así no se paga el lookup del plan de gusto).
     */
    private planesFiltro(): string[] | undefined {
        if (!this.selectedPlanes.length) {
            return undefined;
        }
        if (this.selectedPlanes.length === this.opcionesPlan().length) {
            return undefined;
        }
        return this.selectedPlanes;
    }

    /** Sin filtro (lista vacía) todas las opciones cuentan como incluidas. */
    planSeleccionado(valor: string): boolean {
        return (
            !this.selectedPlanes.length || this.selectedPlanes.includes(valor)
        );
    }

    /**
     * El filtro arranca en "todos" (lista vacía): destildar una opción pasa a
     * seleccionar el resto, y volver a tildarla vuelve a "todos".
     */
    togglePlan(valor: string): void {
        const opciones = this.opcionesPlan();
        if (!this.selectedPlanes.length) {
            this.selectedPlanes = opciones.filter((o) => o !== valor);
        } else if (this.selectedPlanes.includes(valor)) {
            this.selectedPlanes = this.selectedPlanes.filter(
                (o) => o !== valor
            );
        } else {
            this.selectedPlanes = [...this.selectedPlanes, valor];
        }
        if (this.selectedPlanes.length === opciones.length) {
            this.selectedPlanes = [];
        }
        this.paginaActual = 1;
        this.applyFilters();
    }

    limpiarPlanes(): void {
        this.selectedPlanes = [];
        this.paginaActual = 1;
        this.applyFilters();
    }

    checkSedes() {
        this.selectSede = this.sedesByUsuario.map((sede) => sede._id);
    }

    toggleSede(id: string): void {
        if (this.selectSede.includes(id)) {
            this.selectSede = this.selectSede.filter((s) => s !== id);
        } else {
            this.selectSede = [...this.selectSede, id];
        }
        this.cargarSolicitudesPorSede(this.selectSede);
    }

    toggleEstado(number: number): void {
        if (this.selectedEstados.includes(number)) {
            this.selectedEstados = this.selectedEstados.filter(
                (e) => e !== number
            );
        } else {
            this.selectedEstados = [...this.selectedEstados, number];
        }
        this.cargarSolicitudesPorEstado(this.selectedEstados);
    }

    async cargarSolicitudesPorSede(sedes: string[]) {
        if (sedes) {
            await this.applyFilters();
        }
    }

    async cargarSolicitudesPorEstado(selectedEstados: number[]) {
        this.selectedEstados = selectedEstados;
        await this.applyFilters();
    }

    openDialogModalSolicitud(): void {
        const dialogRef = this.dialog.open(OfertasSolicitudComponent, {
            width: '100vw',
            height: '100vh',
            maxWidth: '100vw',
            maxHeight: '100vh',
            panelClass: ['full-screen-dialog', 'ds-dialog'],
            disableClose: true,
        });
        dialogRef.afterClosed().subscribe();
    }

    async applyFilters(): Promise<void> {
        // Todos los filtros se resuelven server-side; recargamos la página 1.
        await this.fetchPage(1);
    }

    async buscarTexto(): Promise<void> {
        // El buscador de texto recorre todo el historial: sin filtro de fechas.
        this.modoBusqueda = 'texto';
        this.paginaActual = 1;
        await this.fetchPage(1);
    }

    async limpiarBusqueda(): Promise<void> {
        if (!this.textoFiltro) {
            return;
        }
        this.textoFiltro = '';
        this.modoBusqueda = 'rango';
        this.paginaActual = 1;
        await this.fetchPage(1);
    }

    applyFilter(event?: Event) {
        if (event) {
            this.textoFiltro = (event.target as HTMLInputElement).value;
        }
        this.buscarTexto();
    }

    abrirInfoEstados(): void {
        this.modalCustom.abrirPopup({
            tipo: 'info',
            titulo: 'Información sobre Estados',
            textoBoton: 'Entendido',
            ancho: '620px',
            contenido: this.infoEstadosTpl,
            mensaje:
                'Aplica únicamente a los trámites <strong>Medicamentos</strong> y <strong>Empadronamiento medicación crónica</strong>.',
        });
    }

    getKeys(obj: { [key: string]: number }): string[] {
        return Object.keys(obj);
    }

    async seleccionarActividad(actividad: Actividad) {
        if (this.flagSolicitudesCargadas) {
            this.idActividadSeleccionada = actividad._id;
            await this.fetchPage(1);
        }
    }

    async seleccionarTodos() {
        if (this.flagSolicitudesCargadas) {
            this.idActividadSeleccionada = this.TODOS_ID;
            await this.fetchPage(1);
        }
    }

    toggleOrdenFecha(): void {
        if (this.sortBy === 'fecha') {
            this.ordenFecha = this.ordenFecha === 'asc' ? 'desc' : 'asc';
        }
        this.sortBy = 'fecha';
        this.paginaActual = 1;
        this.fetchPage(1);
    }

    /**
     * Click en el header Plan: primer click ordena por plan ascendente;
     * los siguientes invierten. La tabla ordena por una columna a la vez.
     */
    toggleOrdenPlan(): void {
        if (this.sortBy === 'plan') {
            this.ordenPlan = this.ordenPlan === 'asc' ? 'desc' : 'asc';
        } else {
            this.sortBy = 'plan';
            this.ordenPlan = 'asc';
        }
        this.paginaActual = 1;
        this.fetchPage(1);
    }

    /**
     * Click en el header Dif.: primer click pone primero los netos mas bajos
     * (los que tienen mas anuladas que aprobadas); los siguientes invierten.
     */
    toggleOrdenDif(): void {
        if (this.sortBy === 'dif') {
            this.ordenDif = this.ordenDif === 'asc' ? 'desc' : 'asc';
        } else {
            this.sortBy = 'dif';
            this.ordenDif = 'asc';
        }
        this.paginaActual = 1;
        this.fetchPage(1);
    }

    getStateName(stateNumber: number): string {
        const estado = this.iAppOfertas.selectEstados.find(
            (e) => e.number === stateNumber,
        );
        return estado ? estado.name : 'Desconocido';
    }

    private debeIncluirSolicitud(solicitud: any, numberState: number): boolean {
        const createdAt = solicitud?.createdAt
            ? new Date(solicitud.createdAt)
            : null;

        if (createdAt && createdAt >= this.FECHA_CORTE_FILTRO) {
            return numberState !== 0;
        }

        return numberState !== 0 && numberState !== 1;
    }

    async verDetalleGecros(identificacion: string) {
        const dialogRef = this.dialog.open(ModalDetalleGecrosComponent, {
            width: '900px',
            maxHeight: '90vh',
            disableClose: true,
            panelClass: 'ds-dialog',
            data: { identificacion },
        });

        dialogRef.afterClosed().subscribe(() => {
            // acciones tras cerrar el modal
        });
    }

    verDetalleSede(idSede: string, idUser: string): void {
        const dialogRef = this.dialog.open(ModalDetalleComponent, {
            width: '620px',
            maxHeight: '90vh',
            disableClose: true,
            panelClass: 'ds-dialog',
            data: { idUser, idSede },
        });

        dialogRef.afterClosed().subscribe(() => {
            // acciones tras cerrar el modal
        });
    }

    getCountLeidas(actividad: Actividad): number {
        return this.solicitudCounts.leidas[actividad.nombre] || 0;
    }

    labelPendientes(cantidad: number): string {
        return `${cantidad} sin leer`;
    }

    labelLeidas(cantidad: number): string {
        return `${cantidad} ${cantidad === 1 ? 'leída' : 'leídas'}`;
    }

    getCountPendientes(actividad: Actividad): number {
        return this.solicitudCounts.pendientes[actividad.nombre] || 0;
    }

    /** Suma de "sin leer" de todos los trámites (badge del sintético "Todos"). */
    getTotalPendientes(): number {
        return this.getKeys(this.solicitudCounts.pendientes).reduce(
            (acc, key) => acc + this.solicitudCounts.pendientes[key],
            0
        );
    }

    /** Suma de "leídas" de todos los trámites (badge del sintético "Todos"). */
    getTotalLeidas(): number {
        return this.getKeys(this.solicitudCounts.leidas).reduce(
            (acc, key) => acc + this.solicitudCounts.leidas[key],
            0
        );
    }

    cambiarPagina(pagina: number): void {
        if (pagina < 1 || pagina > this.totalPaginas) {
            return;
        }
        this.paginaActual = pagina;
        this.fetchPage(pagina);
    }

    cambiarPageSize(size: number): void {
        this.pageSize = size;
        this.paginaActual = 1;
        this.fetchPage(1);
    }

    toggleMenu(event: MouseEvent, solicitud: any): void {
        if (this.menuSolicitud && this.menuSolicitud._id === solicitud._id) {
            this.menuSolicitud = null;
            return;
        }
        const rect = (event.currentTarget as HTMLElement).getBoundingClientRect();
        this.menuPos = {
            top: rect.bottom + 6,
            right: window.innerWidth - rect.right,
        };
        this.menuSolicitud = solicitud;
    }

    cerrarMenu(): void {
        this.menuSolicitud = null;
    }

    abrirDropdown(tipo: 'sede' | 'estado' | 'plan', event: MouseEvent): void {
        if (this.dropdownAbierto === tipo) {
            this.dropdownAbierto = null;
            return;
        }
        const rect = (event.currentTarget as HTMLElement).getBoundingClientRect();
        this.dropdownPos = { top: rect.bottom + 6, left: rect.left };
        this.dropdownAbierto = tipo;
    }

    cerrarDropdown(): void {
        this.dropdownAbierto = null;
    }

    todasSedesSeleccionadas(): boolean {
        return (
            this.sedesByUsuario.length > 0 &&
            this.sedesByUsuario.every((sede) =>
                this.selectSede.includes(sede._id)
            )
        );
    }

    todasEstadosSeleccionados(): boolean {
        return (
            this.estadosChips.length > 0 &&
            this.estadosChips.every((estado) =>
                this.selectedEstados.includes(estado.number)
            )
        );
    }

    toggleTodoSedes(): void {
        if (this.todasSedesSeleccionadas()) {
            this.selectSede = [];
        } else {
            this.selectSede = this.sedesByUsuario.map((sede) => sede._id);
        }
        this.cargarSolicitudesPorSede(this.selectSede);
    }

    toggleTodoEstados(): void {
        if (this.todasEstadosSeleccionados()) {
            this.selectedEstados = [];
        } else {
            this.selectedEstados = this.estadosChips.map((e) => e.number);
        }
        this.cargarSolicitudesPorEstado(this.selectedEstados);
    }

    mostrarTooltip(event: MouseEvent, texto: string): void {
        if (this.tooltipTimeout) {
            clearTimeout(this.tooltipTimeout);
            this.tooltipTimeout = null;
        }
        const rect = (event.currentTarget as HTMLElement).getBoundingClientRect();
        this.tooltipTexto = texto;
        this.tooltipPos = {
            top: rect.bottom + 6,
            left: rect.left + rect.width / 2,
        };
        this.tooltipVisible = true;
    }

    ocultarTooltip(): void {
        if (this.tooltipTimeout) {
            clearTimeout(this.tooltipTimeout);
        }
        this.tooltipTimeout = setTimeout(() => {
            this.tooltipVisible = false;
            this.tooltipTimeout = null;
        }, 150);
    }

    accionVerSolicitud(): void {
        const s = this.menuSolicitud;
        this.cerrarMenu();
        if (s) {
            this.verSolicitud(s);
        }
    }

    accionDetalleGecros(): void {
        const s = this.menuSolicitud;
        this.cerrarMenu();
        if (s) {
            this.verDetalleGecros(s.usuario_identificacion);
        }
    }

    accionDetalleSede(): void {
        const s = this.menuSolicitud;
        this.cerrarMenu();
        if (s) {
            this.verDetalleSede(s.signoSedeId, s.usuario_id);
        }
    }

    trackBySolicitud(index: number, s: any): string {
        return s._id;
    }

    getEstadoChipClase(stateNumber: number): string {
        switch (stateNumber) {
            case 4:
                return 'estado--aprobado';
            case 3:
                return 'estado--auditoria';
            case 2:
                return 'estado--revision';
            case 7:
                return 'estado--recupero';
            case 6:
                return 'estado--espera';
            case 5:
                return 'estado--anulado';
            default:
                return 'estado--neutro';
        }
    }

    estadosChips: { number: number; name: string; detail?: string }[] = [];

    @HostListener('document:keydown.escape')
    onEscape(): void {
        this.cerrarMenu();
        this.cerrarDropdown();
    }

    async verSolicitud(solicitud: Solicitud) {
        this.loading = true;
        try {
            const sol = await this.solicitudesService.getSolicitudById(
                solicitud._id
            );
            this.solicitudesService.setSolicitudSeleccionada(sol);
            this.solicitudesService.setCoberturaSolicitud(
                (solicitud as any).usuario_gecros_cobertura
            );
            const eraSinLeer = !solicitud.leido;
            await this.updateSolicitudLeido(sol);
            solicitud.leido = true;
            if (eraSinLeer) {
                this.marcarLeidaEnContadores(solicitud);
            }
            this.openDialogModalSolicitud();
        } catch (error) {
            console.error('Error al ver la solicitud:', error);
        } finally {
            this.loading = false;
        }
    }

    async updateSolicitudLeido(sol: Solicitud) {
        const solicitud: any = {
            _id: sol._id,
            leido: true,
            titular: sol.titular,
            usuario: sol.usuario,
            pais: sol.pais._id,
            actividad: sol.actividad._id,
        };

        await this.solicitudesService.updateSolicitudLeido(sol._id, solicitud);
    }

    /** Refleja localmente una solicitud recién leída en los contadores por trámite. */
    private marcarLeidaEnContadores(solicitud: any): void {
        const nombre = solicitud.actividad_nombre || 'Desconocida';
        const pend = this.solicitudCounts.pendientes[nombre] || 0;
        if (pend > 0) {
            this.solicitudCounts.pendientes[nombre] = pend - 1;
            this.solicitudCounts.leidas[nombre] =
                (this.solicitudCounts.leidas[nombre] || 0) + 1;
            this.recalcularTotales();
        }
    }

    async exportarSolicitudes(): Promise<void> {
        if (!this.fechaDesdeStr || !this.fechaHastaStr) {
            this.snackBar.open(
                'Por favor, seleccione ambas fechas para exportar',
                'Cerrar',
                { duration: 3000 }
            );
            return;
        }

        this.loading = true;

        try {
            const fechaParams = {
                fechaDesde: this.fechaDesdeStr,
                fechaHasta: this.fechaHastaStr,
            };

            const sedesParams: any = {
                signoSedes: this.selectSede,
            };

            // RECUPEROSUR exporta solo su circuito (mismo filtro que la bandeja).
            const allSolicitudes = this.esPerfilRecupero
                ? await this.solicitudesService.getSolicitudesRecuperoExtendido(
                      sedesParams,
                      fechaParams
                  )
                : await this.solicitudesService.getSolicitudesBySedeExtendido(
                      sedesParams,
                      fechaParams
                  );

            const allSolicitudesConCampos = allSolicitudes as any[];

            let solicitudesFiltradas = allSolicitudesConCampos.filter(
                (solicitud) => {
                    const numberState = solicitud?.lastState_numberState ?? -1;
                    return this.debeIncluirSolicitud(solicitud, numberState);
                }
            );

            // Excluir solicitudes de inscripción también del Excel
            solicitudesFiltradas = solicitudesFiltradas.filter(
                (s) => !this.idsInscripciones.includes(s.actividadId)
            );

            if (!solicitudesFiltradas || solicitudesFiltradas.length === 0) {
                this.snackBar.open(
                    'No hay solicitudes para exportar en el rango de fechas seleccionado',
                    'Cerrar',
                    { duration: 3000 }
                );
                this.loading = false;
                return;
            }

            const datosExcel =
                this.prepararDatosParaExcel(solicitudesFiltradas);
            this.generarExcel(datosExcel);

            this.snackBar.open(
                `Exportadas ${solicitudesFiltradas.length} solicitudes`,
                'Cerrar',
                { duration: 3000 }
            );
        } catch (error) {
            console.error('Error al exportar solicitudes:', error);
            this.snackBar.open('Error al exportar las solicitudes', 'Cerrar', {
                duration: 3000,
            });
        } finally {
            this.loading = false;
        }
    }

    prepararDatosParaExcel(solicitudes: any[]): any[] {
        return solicitudes.map((solicitud) => {
            const fechaFormateada = this.formatearFechaExcel(
                solicitud.createdAt
            );
            const fechaUltimaModFormateada = this.formatearFechaExcel(
                solicitud.dateLastState
            );

            return {
                'Número de Solicitud': solicitud._nro,
                DNI: solicitud.usuario_identificacion || 'N/A',
                Paciente: solicitud.beneficiario || 'N/A',
                Fecha: fechaFormateada,
                Procedimiento: solicitud.actividad_nombre || 'N/A',
                Plan: solicitud.plan || 'Sin plan',
                Solicitante: solicitud.solicitante || 'N/A',
                Sede: solicitud.signoSedeNombre || 'N/A',
                Administrador: solicitud.lastState_userName || 'N/A',
                Estado: `${solicitud.lastState_state}`,
                Observaciones: solicitud.lastState_observaciones || 'N/A',
                'Estados Historicos': solicitud.historicoEstados || 'N/A',
                'Fecha del Ultimo Estado': fechaUltimaModFormateada || 'N/A',
            };
        });
    }

    formatearFechaExcel(fechaISO: string | Date): string {
        try {
            const fechaString =
                typeof fechaISO === 'string'
                    ? fechaISO
                    : fechaISO instanceof Date
                    ? fechaISO.toISOString()
                    : '';

            const fecha = new Date(fechaString);
            const dia = fecha.getDate().toString().padStart(2, '0');
            const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
            const anio = fecha.getFullYear();
            const horas = fecha.getHours().toString().padStart(2, '0');
            const minutos = fecha.getMinutes().toString().padStart(2, '0');

            return `${dia}/${mes}/${anio} ${horas}:${minutos}`;
        } catch (error) {
            console.error('Error formateando fecha:', error);
            return 'Fecha inválida';
        }
    }

    generarExcel(datos: any[]): void {
        const worksheet = XLSX.utils.json_to_sheet(datos);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Solicitudes');

        const wscols = [
            { wch: 20 },
            { wch: 12 },
            { wch: 25 },
            { wch: 20 },
            { wch: 35 },
            { wch: 14 },
            { wch: 30 },
            { wch: 20 },
            { wch: 30 },
            { wch: 18 },
            { wch: 50 },
            { wch: 50 },
            { wch: 20 },
        ];
        worksheet['!cols'] = wscols;

        const nombreArchivo = `Solicitudes_${this.fechaDesdeStr}_a_${this.fechaHastaStr}.xlsx`;

        XLSX.writeFile(workbook, nombreArchivo, { compression: true });
    }
}